// 方向枚举
export var Direction;
(function (Direction) {
    Direction[Direction["TOP"] = 0] = "TOP";
    Direction[Direction["RIGHT"] = 1] = "RIGHT";
    Direction[Direction["BOTTOM"] = 2] = "BOTTOM";
    Direction[Direction["LEFT"] = 3] = "LEFT";
})(Direction || (Direction = {}));
// [0,-1] 右：[1,0] 下 [1,1] 左 [-1,0]
export const DIRECTION_VECTOR = {
    [Direction.TOP]: [0, -1],
    [Direction.RIGHT]: [1, 0],
    [Direction.BOTTOM]: [0, 1],
    [Direction.LEFT]: [-1, 0],
};
export var TreeNodeType;
(function (TreeNodeType) {
    TreeNodeType[TreeNodeType["MOLD"] = 1] = "MOLD";
    TreeNodeType[TreeNodeType["CONDITION"] = 2] = "CONDITION";
    TreeNodeType[TreeNodeType["TOOLS"] = 3] = "TOOLS";
})(TreeNodeType || (TreeNodeType = {}));
// 工具状态
export var ToolsStatusEnum;
(function (ToolsStatusEnum) {
    ToolsStatusEnum[ToolsStatusEnum["DEFAULT"] = 0] = "DEFAULT";
    ToolsStatusEnum[ToolsStatusEnum["SELECT"] = 1] = "SELECT";
    ToolsStatusEnum[ToolsStatusEnum["SELECT_ERROR"] = 2] = "SELECT_ERROR";
    ToolsStatusEnum[ToolsStatusEnum["EDIT_ERROR"] = 3] = "EDIT_ERROR";
    ToolsStatusEnum[ToolsStatusEnum["VERIFY_ERROR"] = 4] = "VERIFY_ERROR";
})(ToolsStatusEnum || (ToolsStatusEnum = {}));
// 工具中的组件枚举
export var ToolsComponentNameEnum;
(function (ToolsComponentNameEnum) {
    ToolsComponentNameEnum["SCORE_SELECT"] = "scoreSelect";
    ToolsComponentNameEnum["CONDITION_SELECT"] = "conditionSelect";
    ToolsComponentNameEnum["DAY_INPUT"] = "dayInput";
    ToolsComponentNameEnum["TIME_SELECT"] = "timeSelect";
    ToolsComponentNameEnum["RATIO_SELECT"] = "ratioSelect";
    ToolsComponentNameEnum["PRICE_SPREAD_SELECT"] = "priceSpreadSelect";
    ToolsComponentNameEnum["NUM_INPUT"] = "numInput";
})(ToolsComponentNameEnum || (ToolsComponentNameEnum = {}));
// 操作类型
export var OperationType;
(function (OperationType) {
    OperationType[OperationType["INSERT"] = 0] = "INSERT";
    OperationType[OperationType["APPEND"] = 1] = "APPEND";
})(OperationType || (OperationType = {}));
// 交易字段
export const TRADIND_KEYS = ['buy', 'sell'];
// 条件节点头部高度
export const CONDITION_HEAD_NODE_HEIGHT = 32;
// 图标的尺寸
export const ICON_SIZE = 20;
